(function($) {
  
  $('.js-radio-toggle').click(function() {
    var data_value = $(this).attr('data-toggle');
    var data_wrapper = $(this).parent().next();

    $(data_wrapper).children(".js-radio-receiver").hide();    
    $("#"+data_value).show();

  });

})(jQuery);
